// Libraries
import React from 'react';

// Components
import { CardBlock, CardText } from 'Components/flowChart/components/NodePreview/components/styled';

// Types
import { IMetadata as NodeWaitEventMetadata } from 'Components/flowChart/components/NodePreview/components/NodeWaitEvent/types';
import { IMetadata } from 'Components/flowChart/components/NodePreview/components/NodeWaitEventHappened/types';
import { INodePreviewProps } from 'Components/flowChart/components/NodePreview/types';
import { INode } from 'Components/flowChart/types';

// Utils
import { deltaToContent } from 'Components/flowChart/utils';

const PATH = 'components/components/flowChart/components/Card/components/NodeWaitEventHappened/index.tsx';

export interface INodeWaitEventHappened extends INodePreviewProps<IMetadata> {}

const NodeWaitEventHappened: React.FC<INodeWaitEventHappened> = (props) => {
	try {
		const { node, flattenNodes } = props;
		const parentNode: INode<Partial<NodeWaitEventMetadata>> = flattenNodes[node.parentId!];

		if (parentNode) {
			const waitingTimeout = parentNode.metadata?.waitingTimeout;
			const deltaContent = deltaToContent(waitingTimeout?.delta!);

			if (deltaContent) {
				return (
					<CardBlock>
						<CardText>{`Within: ${deltaContent}`}</CardText>
					</CardBlock>
				);
			}
		}

		return null;
	} catch (e) {
		props.onError?.(e, {
			component: PATH,
			action: 'render -> NodeWaitEventHappened',
			args: { props },
		});

		return null;
	}
};

export default NodeWaitEventHappened;
